import { flow, getEnv, types } from 'mobx-state-tree';

import { createMapWithTransform } from 'utils/store/createMap';
import FireConfigModel, { createFireConfigModel, FireConfigModelType } from './FireConfigModel';
import { ListLoadingStateEnum } from './LoadingStateEnums';
import { AdvancedStoreEnv } from './StoreEnv';

const FireConfigStore = types
  .model('FireConfigStore', {
    listLoadingState: types.maybe(ListLoadingStateEnum),
    fireConfigs: types.maybe(types.map(FireConfigModel))
  })
  .actions(self => {
    const getFireConfigs = flow(function*() {
      const { client, applicationStore } = getEnv<AdvancedStoreEnv>(self);

      try {
        self.listLoadingState = 'loading';
        const result: any = yield client.getFireConfigs();

        self.fireConfigs = createMapWithTransform(result, createFireConfigModel);
        self.listLoadingState = undefined;
      } catch (error: any) {
        if (process.env.NODE_ENV !== 'production') {
          // tslint:disable-next-line
          console.error('FireConfigStore | getFireConfigs', error, error.body);
        }

        if (client.isNotFound(error)) {
          self.listLoadingState = 'not_found';
          return undefined;
        }

        if (applicationStore.handleAppError(error)) {
          return undefined;
        }

        self.listLoadingState = 'load_error';

        return undefined;
      }
    });

    return {
      getFireConfigs,
    };
  }).views((self) => {
    return {
      get isListLoading(): boolean {
        return self.listLoadingState === 'loading';
      },
      get isListDeleting(): boolean {
        return self.listLoadingState === 'deleting';
      },
      get isListBusy(): boolean {
        return this.isListLoading || this.isListDeleting;
      },
      get isListError(): boolean {
        return (
          self.listLoadingState === 'load_error' ||
          self.listLoadingState === 'access_denied' ||
          self.listLoadingState === 'feature_disabled'
        );
      },
      get fireConfigList(): FireConfigModelType[] {
        const list: FireConfigModelType[] = [];

        if (!self.fireConfigs) {
          return list;
        }


        for (const fireConfig of self.fireConfigs.values()) {
          list.push(fireConfig);
        }

        return list;
      },
    };
  });

export type FireConfigStoreType = typeof FireConfigStore.Type;
export default FireConfigStore;
